<template>
    <div class="maincontainer" :ref="topRef" :class="{ disabled: isDisabled }">
        <div class="maincolumn">
            <template v-if="viewData.init">
                <!-- TEMPORARY ADDED THIS IF SO SPECIFIC CODE CAN BE ADDED FOR COUPLED PARTS -->
                <template v-for="part in viewData.config?.settings?.parts ?? ['default']">
                    <component v-if="part" :is="part" />
                </template>
            </template>
        </div>
    </div>
    <Teleport to="#app">
        <workflowcardPopover />
    </Teleport>
</template>

<!--            <template v-if="viewData.workflowcard_id">-->
<!--                <button class="backto more-inline" type="button" @click.prevent="goBack()">-->
<!--                    <Icon name="arrow" />-->
<!--                    <span class="title">{{ trans('Terug naar vorige pagina') }}</span>-->
<!--                </button>-->
<!--            </template>-->

<script>
import {defineComponent, provide, watch, computed, reactive, onMounted, onUnmounted, inject, ref} from "vue";

import { useRoute, useRouter } from "vue-router";

import Icon from "components/icon";
import trans from "helpers/_translation";
import {env} from "config";

import { contact, item, fetchItem, usergroup_ids, related_value, department_value, portalStore, isCompanyUndefinedAllowed } from "store/portal";
import { company, company_title } from "store/company";
import { view_configuration, view_visible, view_configuration_by_target_and_tab_id , checkDependecies } from "store/view";
import { resolveRelatedFilters, getFiltersAndStore, generalFilters, resolveFilters, resolveAppFilters } from "store/filters";
import { resetSortingData } from "store/sorting";
import { workflowlayout, workflowlayoutdetailtab, workflowlayoutcardoverview } from "store/workflow";

import { hasQuery, getQuery, setQuery, getUrlWithQueryItemReplaced } from "helpers/_structure";
import { getDataAsync, getDataWithoutLimit } from "helpers/_api";
import { apiHostname } from "config";

import { resolveData } from "helpers/_data";

import { workflowproperties } from "store/workflow";
import { sortingData } from "store/sorting";
import { department_id } from "store/department";

import { closeWorkflowcardPopover } from "store/workflowcard-popover";


import workflowcardPopover from "view/dashboard/includes/workflowcard-popover";

import Parts from "view/dashboard/parts/_index";

export default defineComponent({
    name: "dashboardView",
    components: {
        Icon,
        workflowcardPopover,
        ...Parts
    },
    setup() {

        const handleConfirm = inject("handleConfirm");

        const route = useRoute();
        const router = useRouter();

        const currentPayload = computed(() => {
            return route.params.payload ? JSON.parse(atob(route.params.payload)) : null;
        });

        const config = computed(() => {
            return view_configuration(route.name);
        });
        const PAGE_KEY = "page";
        const appData = inject("appData");
        const viewData = reactive({
            init: false,
            ticker: 0, // Used for history log for example, updating the feed
            overview_ticker: 0,
            config: config,

            workflowboard_id: computed(() => parseInt(currentPayload.value?.workflowboard_id ?? viewData.config?.settings?.target?.workflowboard_id)),
            workflowphase_id: computed(() => parseInt(currentPayload.value?.workflowphase_id ?? viewData.config?.settings?.target?.workflowphase_id)),
            workflowcard_id: computed(() => {
                let tmpWorkflowcardId = currentPayload.value?.workflowcard_id ?? viewData.config?.settings?.target?.workflowcard_id;
                if (tmpWorkflowcardId) {
                    if (`${tmpWorkflowcardId}`.startsWith("%department.")) {
                        tmpWorkflowcardId = department_value(tmpWorkflowcardId);
                    } else if (`${tmpWorkflowcardId}`.startsWith("%")) {
                        tmpWorkflowcardId = tmpWorkflowcardId.replace("%", "");
                        tmpWorkflowcardId = related_value(tmpWorkflowcardId);
                    }
                }
                return tmpWorkflowcardId;
            }),
            workflowpropertyfieldgroup_id: computed(() => {
                return config.value?.settings?.target?.workflowpropertyfieldgroup_id;
            }),

            order: computed(() => {
                return config.value?.settings?.target?.order ?? null;
            }),
            sort: computed(() => {
                return config.value?.settings?.target?.sort ?? null;
            }),
            realtime: computed(() => {
                // Used to define if getDataWithoutLimit should show result instant
                return config.value?.settings?.target?.realtime ?? false;
            }),

            searchable_property_names: computed(() => viewData.config?.settings?.target?.searchable_property_names ?? []),
            extra_filters: computed(() => viewData.config?.settings?.target?.extra_filters),
            search_value: "",

            // Data specific
            loading: true,
            edited: false,
            item: {
                data: null,
                tabs: null,
                overviews: null,
                active_tab: null
            },

            _meta: null,
            data: [],

            visible: {
                sidecolumn: computed(() => viewData.config?.settings?.disabled?.sidecolumn ? false : true),
                buttons: computed(() => viewData.config?.settings?.disabled?.buttons ? false : true),
                tab_navigation: computed(() => viewData.config?.settings?.disabled?.tab_navigation ? false : true)
            },

            layout: computed(() => {
                if (config.value?.settings?.workflowcard_id) {
                    return "edit";
                }
                return config.value?.settings?.layout ?? "tabular";
            }),
            layout_forced: computed(() => {
                return !!config.value?.settings?.layout;
            }),

            title: computed(() => {
                return config.value.title ?? "";
            }),
            subtitle: computed(() => {
                if (typeof config.value.subtitle === "String") {
                    return config.value.subtitle;
                }
                return company_title.value ?? "";
            }),

            // Specific changes for detail page
            detail_title_prefix: computed(() => {
                return config.value.detail_title_prefix ?? ""
            }),

            // Cachable data
            workflowboardbuttonbyboardid: {},
        });
        // Set settings and watch for props changes
        const settings = reactive({
            limit: 15,
            current: (hasQuery(PAGE_KEY) ? getQuery(PAGE_KEY) : 1),
            total: computed(() => viewData._meta?.total)
        });

        const text = (key) => {
            return computed(() => {
                return viewData.config?.settings?.text?.[key] ?? key;
            }).value;
        };
        provide("text", text);


        const isAddVisible = computed(() => {
            if (viewData.config?.settings?.disabled?.add) {
                return false;
            }
            return true;
        })
        const isBottomVisible = computed(() => {
            return [
                !!viewData.searchable_property_names.length,
                isAddVisible.value
            ].some(Boolean) && viewData.workflowboard_id && !viewData.workflowcard_id;
        });

        provide("isAddVisible", isAddVisible);
        provide("isBottomVisible", isBottomVisible);

        provide("PAGE_KEY", PAGE_KEY);
        provide("viewData", viewData);
        provide("overviewSettings", settings);

        const isButtonsVisible = computed(() => {
            if (viewData.config?.settings?.disabled?.buttons) {
                return false;
            }
            return !!(viewData.workflowcard_id || viewData.workflowboard_id);
        });
        provide("isButtonsVisible", isButtonsVisible);


        const allow = (key) => {
            return computed(() => {
                const defaultMap = {
                    "view": true,
                    "delete": false
                };
                // Check for defaults
                if ((viewData.config?.settings?.allow?.[key] === undefined) && defaultMap[key] !== undefined) {
                    return defaultMap[key];
                }
                return !!viewData.config?.settings?.allow?.[key];
            }).value;
        };

        const show = (key) => {
            return computed(() => {
                const defaultMap = {
                    "state": false
                };
                // Check for defaults
                if ((viewData.config?.settings?.show?.[key] === undefined) && defaultMap[key] !== undefined) {
                    return defaultMap[key];
                }
                return !!viewData.config?.settings?.show?.[key];
            }).value;
        };
        provide("allow", allow);
        provide("show", show);

        const extra_tabs = computed(() => {
            const result =  [
                {
                    label: "Documenten",
                    property: {
                        id: "files",
                        type: "extra",
                        icon: "paperclip"
                    }
                },
	            {
	                label: "Berichten",
	                property: {
	                    id: "inbox",
	                    type: "extra",
                        icon: "message2"
	                }
	            },
                {
                    label: "Opmerkingen",
                    property: {
                        id: "reactions",
                        type: "extra",
                        icon: "message2"
                    }
                },
                {
                    label: "Historie",
                    property: {
                        id: "historylog",
                        type: "extra",
                        icon: "history2"
                    }
                }
            ];

            if (viewData.config?.settings?.sidecolumn_tabs?.includes("editlog")) {
                result.push({
                    label: "Bewerkgegevens",
                    property: {
                        id: "editlog",
                        type: "extra"
                    }
                });
            }

            return result;
        });

        const overrule = (key, value) => {
            return computed(() => {
                if (viewData.config?.settings?.overrule?.[key]?.[value]) {
                    return viewData.config?.settings.overrule[key][value];
                }
                return value;
            }).value;
        };
        provide("overrule", overrule);

        const tab_positions = [
            "sidecolumn"
        ];
        const allowInbox = () => {
            return computed(() => {
                const workflowboard = item("workflowboard", viewData.workflowboard_id);
                if (!workflowboard) return false;
                return workflowboard.data?.inbox_available === "Y";
            }).value;
        };
        const all_tabs = () => {
            return computed(() => {
                if (!viewData.workflowcard_id) return [];
                if (viewData?.item?.tabs === null) return [];
                const details = viewData.item.tabs.filter(a => {
                    return (!a?.disallowed?.read?.some(b => usergroup_ids.value.map(c => `${c}`).includes(`${b}`)))
                        && (!viewData.config?.settings?.disabled?.details || !viewData.config?.settings?.disabled?.details.includes(`${a.property.id}`));
                }).map(a => {
                    a.property.type = "tab";
                    return a;
                });

                const overviews = viewData.item.overviews.map(a => {
                    return {
                        label: a.title,
                        property: {
                            id: a.id,
                            type: "overview"
                        },
                        data: {
                            ...a
                        }
                    };
                }).filter(a => {
                    return !viewData.config?.settings?.disabled?.overviews || !viewData.config?.settings?.disabled?.overviews.includes(`${a.property.id}`);
                });

                const extras = extra_tabs.value.filter(tab => {
                    if ((tab.property.id === "inbox") && !allowInbox()) {
                        return false;
                    }
                    return !viewData.config?.settings?.disabled?.tabs || !viewData.config?.settings?.disabled?.tabs.includes(`${tab.property.id}`);
                });
                return [...details, ...overviews, ...extras];
            }).value;
        };
        const tabs = (position = "maincolumn") => {
            return computed(() => {
                let data = [...all_tabs()];
                if (tab_positions.includes(position)) {
                    const tmpSettings = viewData.config?.settings?.[`${position}_tabs`] ?? [];
                    data = data.filter(a => tmpSettings.includes(a.property.id));
                } else {
                    tab_positions.forEach(tab_position => {
                        const tmpSettings = viewData.config?.settings?.[`${tab_position}_tabs`] ?? [];
                        data = data.filter(a => !tmpSettings.includes(a.property.id));
                    });
                }

                // Tabs related to a page view
                return data.filter(a => {
                    if (!a?.property?.id) {
                        // Other kind of tab
                        return true;
                    }

                    // Check if the matching view configuration is visible.
                    if (viewData.config?.settings?.target) {
                        const targetConfiguration = view_configuration();
                        if (!targetConfiguration || view_visible(targetConfiguration?.name)) {
                            return true;
                        }
                    }
                    return false;
                });
                return data;
            }).value;
        };

        const tab_current = () => {
            if (!viewData.item.active_tab) return null;
            // Define our active
            const tab_type = viewData.item.active_tab.split("_")[0];
            const tab_id = viewData.item.active_tab.split("_")[1];
            // Get our tab object
            return tabs().find(a => a.property.id == tab_id && a.property.type == tab_type);
        };
        const handleTab = (tab_type, tab_id) => {
            // console.trace("handleTab", tab_type, tab_id);
            if (!tab_id) return;
            handleConfirm().then(
                () => {
                    viewData.item.active_tab = `${tab_type}_${tab_id}`;
                },
                () => {
                    // Rejected
                }
            );
        };
        const handleTabClick = (tab_type, tab_id) => {
            const targetConfiguration = view_configuration_by_target_and_tab_id(viewData.config?.settings.target, tab_id);
            if (targetConfiguration) {
                router.push({
                    name: targetConfiguration.name,
                    query: {}
                });
            } else {
                handleTab(tab_type, tab_id);
            }
        };
        const tab_active = (tab_type, tab_id) => {
            return computed(() => {
                return viewData.item.active_tab == `${tab_type}_${tab_id}`;
            }).value;
        };
        const tab_exists = (tab_type, tab_id) => {
            return computed(() => {
                return tabs()?.some(a => a.property.id == tab_id && a.property.type == tab_type);
            }).value;
        };
        const tab_editable = (tab_type, tab_id) => {
            const target_tab = tabs().find(a => a.property.id == tab_id && a.property.type == tab_type);
            if (!target_tab) return false;
            return !target_tab?.disallowed?.edit?.some(b => usergroup_ids.value.map(c => `${c}`).includes(`${b}`));
        };

        let detailtab_watcher;
        onMounted(() => {
            checkDependecies(route.name).then(valid => {
                viewData.init = true;
            });

            watch(
                () => [viewData.item.tabs, viewData.item.overviews],
                () => {
                    if (!tabs().length) return;

                    if (!viewData.workflowpropertyfieldgroup_id) {
                        const tmpTab = tabs()[0];
                        handleTab(tmpTab.property.type, tmpTab.property.id);
                    }

                    detailtab_watcher = watch(
                        () => viewData.workflowpropertyfieldgroup_id,
                        (id) => {
                            if (tab_active("tab", id).value) return;
                            if (!id) {
                                const tmpTab = tabs()[0];
                                if (tmpTab) {
                                    handleTab(tmpTab.property.type, tmpTab.property.id);
                                }
                                return;
                            }
                            handleTab("tab", id);
                        },
                        {
                            immediate: true
                        }
                    );
                },
                {
                    immediate: true
                }
            );
        });
        onUnmounted(() => {
            detailtab_watcher && detailtab_watcher();
        });

        provide("handleTabClick", handleTabClick);
        provide("tabs", tabs);
        provide("tab_active", tab_active);
        provide("tab_exists", tab_exists);
        provide("tab_editable", tab_editable);
        provide("tab_current", tab_current);

        const appendUrlDefaults = (url) => {
            url = getUrlWithQueryItemReplaced("page", settings.current, url);
            url = getUrlWithQueryItemReplaced("seq", sortingData.column === "default" ? "id" : sortingData.column, url);
            url = getUrlWithQueryItemReplaced("order", sortingData.order, url);
            url = getUrlWithQueryItemReplaced("limit", settings.limit, url);
            return url;
        };
        const searchFilters = computed(() => {
            // Search value is empty, return empty array
            if (!viewData.search_value) return [];
            if (!viewData.searchable_property_names?.length) return [];
            // Define which properties can be filtered
            return [
                [
                    "StudioIbizz\\Workflowproperty\\Filters\\WorkflowpropertySearch",
                    {
                        "column": viewData.searchable_property_names,
                        "value": viewData.search_value.split(" ").join(" AND ")
                    }
                ]
            ];
        });
        provide("searchFilters",searchFilters);

        const previousDepartmentId = ref(department_id.value);

        const fetchData = () => {
            viewData.loading = true;

            const tmpBoardId = `${viewData.workflowboard_id}`;
            const tmpPhaseId = `${viewData.workflowphase_id}`;

            if (!appData.predefined_init && isBottomVisible.value) return;
            if (!viewData.workflowboard_id || !generalFilters.workflowboard?.[viewData.workflowboard_id]) return;

            if (!tmpPhaseId) {
                return;
            }

            resolveAppFilters(viewData.extra_filters).then(extra_filters => {
                if (!generalFilters.workflowboard?.[viewData.workflowboard_id]) {
                    return;
                }
                const filters = resolveFilters([
                    ...searchFilters.value,
                    [
                        "FieldFilter",
                        {
                            "column": "state",
                            "value": "Online"
                        }
                    ],
                    ...generalFilters.workflowboard[viewData.workflowboard_id],
                    ...generalFilters.workflowusergroup,
                    ...generalFilters?.workflowrefine ?? [],
                    ...extra_filters
                ]);

                if (viewData.workflowphase_id) {
                    if (!generalFilters.workflowphase?.[viewData.workflowphase_id]) return;
                    filters.push(...generalFilters.workflowphase[viewData.workflowphase_id]);
                }
                const tmpData = {
                    "data": []
                };

                if (viewData.config?.settings?.parts?.includes("paging")) {
                    viewData.overview_ticker += 1;
                    const url = appendUrlDefaults(`${apiHostname}/api/v1.0/workflowcard`);
                    getDataAsync(url, filters).then(
                        (result) => {
                            // Check if tmp ids still match, otherwise we already switched
                            if (tmpBoardId !== `${viewData.workflowboard_id}` || tmpPhaseId !== `${viewData.workflowphase_id}`) return;
                            // Set data when finished loading instead
                            viewData._meta = result._meta;
                            viewData.data = resolveData(result);
                            viewData.loading = false;
                        }
                    );
                } else if (viewData.workflowphase_id) {
                    viewData.overview_ticker += 1;
                    viewData._meta = null;
                    viewData.data = [];
                    getDataWithoutLimit(`${apiHostname}/api/v1.0/workflowcard?seq=id&order=desc`, filters, tmpData, "data").then(
                        () => {
                            // Check if tmp ids still match, otherwise we already switched
                            if (tmpBoardId !== `${viewData.workflowboard_id}` || tmpPhaseId !== `${viewData.workflowphase_id}`) return;
                            // Set data when finished loading instead
                            viewData.data = tmpData.data;
                            viewData.loading = false;
                        }
                    );
                } else if (previousDepartmentId.value !== department_id.value) {
                    viewData.overview_ticker += 1;
                }
                // Make sure to store previous department id
                previousDepartmentId.value = department_id.value;
            });
        };


        let watcher;
        let watcher2;
        let watcher3;
        let item_watcher;

        const currentWorkflowcard = computed(() => {
            return portalStore["workflowcard"].find(a => {
                return (`${a.data.id}` === `${viewData.workflowcard_id}`) && a.data.version_date;
            }) ?? null;
        });

        const handleDetailData = () => {
            viewData.item.data = null;
            viewData.item.tabs = null;
            item_watcher = watch(
                () => [
                    contact.value,
                    isCompanyUndefinedAllowed.value ? [] : company.value,
                    currentWorkflowcard.value,
                    item("workflowboard", viewData.workflowboard_id),
                    workflowlayoutcardoverview(viewData.workflowboard_id)
                ],
                (newValues, oldValues) => {
                    // Check for version_date since for example workflowcard is filled with .data.id by default
                    if (newValues.some(a => (a === null) || (!Array.isArray(a) && !a?.data?.version_date))) return;
                    viewData.item.data = item("workflowcard", viewData.workflowcard_id);
                    viewData.loading = false;

                    viewData.item.tabs = workflowlayoutdetailtab(viewData.workflowboard_id);
                    viewData.item.overviews = workflowlayoutcardoverview(viewData.workflowboard_id);

                    item_watcher && item_watcher();
                },
                {
                    immediate: true,
                    deep: true
                }
            );
        };
        const handleOverviewData = (search_value = "") => {
            viewData.loading = true;
            viewData.data = [];
            viewData.search_value = search_value;

            getFiltersAndStore("workflowboard", viewData.workflowboard_id).then(() => {
                // Now check for filters and all dependent data
                item_watcher = watch(
                    () => [
                        item("workflowboard", viewData.workflowboard_id),
                        generalFilters.workflowboard?.[viewData.workflowboard_id],
                        viewData.workflowphase_id ? generalFilters.workflowphase?.[viewData.workflowphase_id] : true
                    ],
                    (values) => {
                        if (values.some(a => (a === null) || (typeof a === "undefined") || (!Array.isArray(a) && (typeof a === "Object") && !a?.data?.version_date))) return;
                        fetchData();
                        item_watcher && item_watcher();
                    },
                    {
                        immediate: true
                    }
                );
            });
        };
        provide("handleOverviewData", handleOverviewData);
        const goBack = () => {
            router.back();
        };

        onMounted(() => {
            viewData.loading = true;
            watcher = watch(
                () => [viewData.workflowcard_id, viewData.workflowphase_id, viewData.workflowboard_id],
                (newValues, oldValues) => {
                    // Define if change is triggered by workflowcard switch
                    const isWorkflowcardChange = newValues[0] !== oldValues?.[0];
                    // Define search value, pass old one if needed
                    let searchValue = "";
                    if (oldValues) {
                        searchValue = isWorkflowcardChange ? viewData.search_value : "";
                    }

                    // Fetch all default data
                    viewData.workflowcard_id && fetchItem("workflowcard", viewData.workflowcard_id);
                    // Any other calls can be suspended
                    if (!viewData.workflowboard_id || `${viewData.workflowcard_id}`.startsWith("%")) return;
                    viewData.workflowboard_id && fetchItem("workflowboard", viewData.workflowboard_id);
                    viewData.workflowphase_id && getFiltersAndStore("workflowphase", viewData.workflowphase_id);
                    // Get specific data
                    handleDetailData();
                    handleOverviewData(searchValue);
                },
                {
                    immediate: true
                }
            );


            const boardData = computed(() => [
                item("workflowboard", viewData.workflowboard_id),
                generalFilters.workflowboard?.[viewData.workflowboard_id],
                viewData.workflowphase_id ? generalFilters.workflowphase?.[viewData.workflowphase_id] : true
            ]);

            watcher2 = watch(
                () => [
                    // First set of values
                    contact.value,
                    item("workflowboard", viewData.workflowboard_id),
                    // Second set of values
                    searchFilters.value,
                    generalFilters.workflowboard?.[viewData.workflowboard_id],
                    generalFilters.workflowphase?.[viewData.workflowphase_id],
                    generalFilters.workflowusergroup,
                    generalFilters.workflowrefine,
                    sortingData,
                    appData.predefined_init,
                    isBottomVisible.value,
                    department_id.value,
                    ...boardData.value
                ],
                (newValues, oldValues) => {
                    if (!appData.predefined_init || (!department_id.value && !isCompanyUndefinedAllowed.value)) return;

                    // Check for differences
                    const newValuesTrimmed = newValues.slice(0, newValues.length - boardData.value.length);
                    const oldValuesTrimmed = oldValues ? oldValues.slice(0, oldValues.length - boardData.value.length) : null;
                    if (JSON.stringify(newValuesTrimmed) === JSON.stringify(oldValuesTrimmed)) return;
                    // Check boardData beforehand
                    if (boardData.value.some(a => (a === null) || (typeof a === "undefined") || (!Array.isArray(a) && (typeof a === "Object") && !a?.data?.version_date))) return;

                    // console.log("filters changed:", newValues);
                    fetchData();
                },
                {
                    deep: true
                }
            );

            watcher3 = watch(
                () => portalStore["workflowcard"],
                () => {
                    if (!currentWorkflowcard.value) return;
                    handleDetailData();
                },
                {
                    immediate: true,
                    deep: true
                }
            );



        });
        onUnmounted(() => {
            // Since we leave a view we can reset our data
            resetSortingData();
            watcher && watcher();
            watcher2 && watcher2();
            watcher3 && watcher3();
            item_watcher && item_watcher();
        });


        const handleItemClick = (e, payload) => {
            const payloadData = btoa(JSON.stringify(payload));
            // console.log("route.path",`/${route.path}/${payloadData}`);
            router.push(`${route.path}/${payloadData}`);
        };
        provide("handleItemClick", handleItemClick);


        const goToOverview = (e) => {
            if (!viewData.workflowcard_id) {
                setTimeout(() => {
                    // Get current url and first router.push to / and back to current
                    router.push("/").then(() => {
                        setTimeout(() => {
                            router.back();
                            closeWorkflowcardPopover();
                        }, 100);
                    });
                }, 750);
                return;
            }

            // Remove last part of the URL, the payload
            const parentPath = route.fullPath.split("/");
            parentPath.pop();
            router.push(`${parentPath.join("/")}`);
        };
        provide("goToOverview", goToOverview);

        const handlePagination = (page, force = false) => {
            if (`${settings.current}` === `${page}` && !force) return;
            settings.current = page;
            scrollToTop();
            fetchData();
        };
        provide("handlePagination", handlePagination);


        const topRef = ref(null);
        const scrollToTop = () => {
            setTimeout(() => {
                topRef.value && window.scrollTo({
                    behavior: 'smooth',
                    top: topRef.value.getBoundingClientRect().top - document.body.getBoundingClientRect().top - 30
                });
            }, 200);
        };

        return {
            route,
            trans,
            viewData,

            goBack,

            topRef,

            contact
        }
    }
});
</script>
